import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { request } from "../../config/request.ts";
import DataTable, { Column } from "../../shared/DataTable/index.tsx";
import PageHeader from "../../shared/PageHeader/index.tsx";
import DeleteConfirmation from "../../shared/DeleteConfirmation/index.tsx";
import StatusChip from "../../shared/StatusChip/index.tsx";
import ActionIcons from "../../shared/ActionIcons/index.tsx";
import PageWrapper from "../../shared/PageWrapper/index.tsx";
import { getMenuIcon } from "../../config/menus.tsx";

interface MenuItem {
  id: string;
  menu_name: string;
  route: string;
  icon: string;
  sort_order: number;
  status: boolean;
}

export default function Menus() {
  const navigate = useNavigate();
  const [menus, setMenus] = useState<MenuItem[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(25);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getMenus();
  }, [page, limit, search]);

  const getMenus = async () => {
    setLoading(true);
    const response = await request.post("menus", {
      search: search,
      limit,
      offset: page,
      orderColumn: "sort_order",
      orderDirection: "desc",
    });
    setMenus(response.data.data);
    setTotalCount(response.data.total);
    setLoading(false);
  };

  const handlePaginationChange = (newPage: number, newLimit: number) => {
    setPage(newPage);
    setLimit(newLimit);
  };

  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: "",
    title: null,
  });

  const columns: Column[] = [
    {
      id: "slNo",
      label: "Sl.No",
      minWidth: 60,
      format: (_value, _row, index) => (
        <Box component="span" sx={{ fontWeight: 600, color: "#64748b" }}>
          {page * limit + index + 1}
        </Box>
      ),
    },
    {
      id: "icon",
      label: "Icon",
      minWidth: 60,
      align: "center",
      format: (value) => <Box sx={{ color: "#667eea", display: "flex" }}>{getMenuIcon(value)}</Box>,
    },
    {
      id: "menu_name",
      label: "Menu Name",
      minWidth: 180,
      format: (value) => value,
    },
    {
      id: "route",
      label: "Route",
      minWidth: 150,
      format: (value) => <Box component="span" sx={{ fontFamily: "monospace", color: "#64748b" }}>{value}</Box>,
    },
    {
      id: "sort_order",
      label: "Sort Order",
      minWidth: 110,
      format: (value) => value,
    },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
      align: "center",
      format: (value) => <StatusChip active={value === true} />,
    },
    // {
    //   id: "actions",
    //   label: "Actions",
    //   minWidth: 120,
    //   align: "right",
    //   format: (_value, row) => (
    //     <ActionIcons
    //       actions={[
    //         {
    //           icon: <EditIcon />,
    //           tooltip: "Edit",
    //           onClick: () => navigate(`/admin/menus/${row.id}`),
    //         },
    //         {
    //           icon: <DeleteIcon />,
    //           isDelete: true,
    //           tooltip: "Delete",
    //           onClick: () =>
    //             setDeleteDialog({ open: true, id: row.id, title: row?.menu_name }),
    //         },
    //       ]}
    //     />
    //   ),
    // },
  ];

  return (
    <>
      <PageHeader
        title="Menus"
        showSearch
        searchPlaceholder="Search menus..."
        onSearchChange={(value) => setSearch(value)}
        defaultSearchValue={search}
        primaryButton={{
          label: "Add Menu",
          icon: <AddIcon />,
          onClick: () => {
            navigate("/admin/menus/create");
          },
        }}
      />
      <PageWrapper loading={loading}>
        <DataTable
          columns={columns}
          rows={menus}
          totalCount={totalCount}
          onPaginationChange={handlePaginationChange}
          page={page}
          limit={limit}
        />
        <DeleteConfirmation
          open={deleteDialog.open}
          title={"Delete Menu - " + deleteDialog?.title}
          message="Are you sure you want to delete this menu? This action cannot be undone."
          apiEndpoint={"menus/"}
          deleteId={deleteDialog.id}
          onCancel={() => setDeleteDialog({ open: false, id: "", title: null })}
          refetchApi={() => {
            setPage(0);
            getMenus();
          }}
        />
      </PageWrapper>
    </>
  );
}